import React from "react";
import { AppbarTexts } from "../AppbarTexts";
import { Button } from "../ui/button";
import { MenuItems } from "../../data/types";
import { Link, useLocation } from "react-router-dom";

type MenuPropos = {
  navMenu?: MenuItems[];
};

const Menu: React.FC<MenuPropos> = ({ navMenu = [] }) => {
  const { pathname } = useLocation();

  return (
    <div>
      {" "}
      <div className="flex items-center justify-center space-x-3 ">
        {navMenu.map((item) => (
          <div className="" key={item.id}>
            <AppbarTexts
              className={pathname === item.url ? "text-primary" : ""}
              property1="variant-3"
              text={item.title}
              url={item.url}
            />
          </div>
        ))}

        <Link to={"/contact"}>
          <Button className="w-24 text-white shadow-md bg-primary lg:w-44 shadow-gray-400 ">
            Contact
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Menu;
